import { render, staticRenderFns } from "./TypeWeight.vue?vue&type=template&id=4dc47f1e&"
import script from "./TypeWeight.vue?vue&type=script&lang=js&"
export * from "./TypeWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports